/* P5 10.10: jeden płynny ruch dla rozwijanych elementów karty produktu (decyzja CEO 10.10):
   - karty <details class="sv-karta"> w sekcjach dane-techniczne-* (Specyfikacja / Instrukcja i opis / Bezpieczeństwo i producent),
   - akordeony kolumny zakupu .product__accordion details (Dostawa / Płatności / Zwroty, sections/main-product.liquid).
   Wysokość <details> i przezroczystość treści przez Web Animations API, 400 ms, cubic-bezier(.4,0,.2,1).
   Kliknięcie w summary (także Enter/Spacja - przeglądarka zamienia je na click) przejmuje słuchacz na document w fazie
   capture: preventDefault (bez natywnego przełączenia) + stopPropagation (handler akordeonów z assets/lumin-main.js l.186-225
   nie startuje; jego klasy summary-animation i tak nie mają w motywie CSS).
   Otwieranie: open + overflow hidden, jeden odczyt układu, wysokość zamknięta -> pełna. Zamykanie: pełna -> zamknięta, potem
   zdjęcie open. Ponowne kliknięcie w trakcie = odwrócenie ruchu od bieżącej wysokości. prefers-reduced-motion = samo przełączenie.
   overflow hidden tylko w trakcie ruchu. Ładowany defer z 3 sekcji dane-techniczne-*, startuje raz (flaga globalna). */
(function () {
  if (window.__svRozwijane) return;
  window.__svRozwijane = true;

  var MS = 400;
  var EASE = 'cubic-bezier(.4,0,.2,1)';
  var CEL = 'details.sv-karta, .product__accordion details';
  var stan = new WeakMap(); // <details> -> { otwiera, h: ruch wysokości, o: ruch treści }
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // treść rozwijana: dziecko <details> (.sv-karta__tresc albo .accordion__content, także po owinięciu przez lumin-main.js)
  function tresc(d) {
    for (var c = d.firstElementChild; c; c = c.nextElementSibling) {
      if (c.classList.contains('sv-karta__tresc') || c.classList.contains('accordion__content')) return c;
    }
    return null;
  }

  function koniec(d) {
    var s = stan.get(d);
    if (!s) return;
    stan.delete(d);
    if (!s.otwiera) d.open = false;
    d.classList.remove('sv-rozw-zamyka');
    d.style.overflow = '';
    s.h.cancel();
    s.o.cancel();
  }

  function przelacz(d, sum, c) {
    var s = stan.get(d);
    if (s) {
      s.otwiera = !s.otwiera;
      d.classList.toggle('sv-rozw-zamyka', !s.otwiera);
      s.h.reverse();
      s.o.reverse();
      return;
    }
    var otwiera = !d.open;
    if ((mq && mq.matches) || typeof d.animate !== 'function') {
      d.open = otwiera;
      return;
    }
    // zapisy przed odczytem: overflow hidden zamyka marginesy treści w <details>, więc koniec ruchu nie skacze
    d.style.overflow = 'hidden';
    if (otwiera) d.open = true;
    else d.classList.add('sv-rozw-zamyka');
    var zamk = sum.offsetHeight;
    var pelna = d.offsetHeight;
    var opt = { duration: MS, easing: EASE, fill: 'forwards' };
    s = {
      otwiera: otwiera,
      h: d.animate({ height: otwiera ? [zamk + 'px', pelna + 'px'] : [pelna + 'px', zamk + 'px'] }, opt),
      o: c.animate({ opacity: otwiera ? [0, 1] : [1, 0] }, opt)
    };
    stan.set(d, s);
    s.h.onfinish = function () { koniec(d); };
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || !e.target || !e.target.closest) return;
    var sum = e.target.closest('summary');
    if (!sum) return;
    var akcja = e.target.closest('a, button, input, select, textarea');
    if (akcja && sum.contains(akcja)) return;
    var d = sum.parentElement;
    if (!d || d.tagName !== 'DETAILS' || !d.matches(CEL)) return;
    var c = tresc(d);
    if (!c) return;
    e.preventDefault();
    e.stopPropagation();
    przelacz(d, sum, c);
  }, true);
})();
